<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <vx-card :title="$t('DailyReportList') | ToUppercase">
        <vs-button class="float-left"
                   color="success"
                   type="filled"
                   to="/report/daily/add">{{$t('AddDailyReport')}}
        </vs-button>

        <vs-table :noDataText="$t('NoReportsFound')"
                  max-items="14"
                  pagination
                  search
                  :data="dailyReports">
          <template slot="thead">
            <vs-th sort-key="id">#</vs-th>
            <vs-th sort-key="name">{{$t('Name')}}</vs-th>
            <vs-th sort-key="date">{{$t('Date')}}</vs-th>
            <vs-th sort-key="user">{{$t('User')}}</vs-th>
            <vs-th sort-key="shift">{{$t('Shift')}}</vs-th>
            <vs-th>{{$t('Actions')}}</vs-th>
            <vs-th>{{$t('Export')}}</vs-th>
          </template>
          <template slot-scope="{data}">
            <tbody>
            <vs-tr :data="tr"
                   :key="data[index].id"
                   v-for="(tr, index) in data">
              <vs-td>{{data[index].id}}</vs-td>
              <vs-td>{{data[index].name}}</vs-td>
              <vs-td>{{data[index].date_formated}}</vs-td>
              <vs-td>{{data[index].user_name}}</vs-td>
              <vs-td>{{data[index].shift_name}}</vs-td>
              <vs-td class="grid justify-items-start">
                <vs-button v-if="userId==data[index].userID"
                           color="primary"
                           class="float-left mr-2"
                           @click="$router.push('/report/daily/edit/' + data[index].id)"
                           type="border"
                           icon="build">{{$t('Edit') | ToUppercase}}
                </vs-button>
                <vs-button v-if="admin == 'admin'"
                           color="primary"
                           class="float-left"
                           @click="deleteReport(data[index].id)"
                           type="border"
                           icon="delete">{{$t('Delete') | ToUppercase}}
                </vs-button>
              </vs-td>
              <vs-td>
                <vs-button color="primary"
                           class=""
                           @click="exportPDF(data[index].document_content)"
                           type="border"
                           icon="picture_as_pdf">PDF
                </vs-button>
              </vs-td>
            </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </vx-card>
    </div>
  </div>
</template>
<script>
  import Datepicker from 'vuejs-datepicker'
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'

  import {quillEditor} from 'vue-quill-editor'

  export default {
    filters: {
      ToUppercase: function(value) {
        if (!value) return ''
        value = value.toString()
        return value.toUpperCase()
      }
    },
    components: {
      Datepicker,
      quillEditor
    },
    data() {
      return {
        reportName: '',
        selectedShift: 0,
        shifts: [],
        reportDate: null,
        content: ``,
        dailyReports: [],
        userId: 0,
        admin: ''
      }
    },
    methods: {
      updateDailyReports() {
        this.$vs.loading()

        const thisIns = this
        this.$http.get('/report?type=daily')
          .then(function(response) {
            thisIns.dailyReports = response.data
          }).catch(function() {
          thisIns.$vs.notify({
            text: 'Napaka pri pridobivanju dnevnih poročil.',
            color: 'danger',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
        }).finally(function() {
          thisIns.$vs.loading.close()
        })
      },
      exportPDF(html) {
        this.$vs.loading()

        const thisIns = this
        this.$http.post('/report/generatePdf', {
          html: html
        }).then(function(response) {
          window.open('/api/pdf/report/' + response.data + '?type=daily')

          thisIns.$vs.notify({
            text: 'PDF uspečno generiran',
            color: 'success'
          })
        }).catch(function() {
          thisIns.$vs.notify({
            text: 'Napaka pri generiranju.',
            color: 'danger',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
        }).finally(function() {
          thisIns.$vs.loading.close()
        })
      },
      deleteReport(id) {
        this.$vs.loading()

        const thisIns = this
        this.$http.delete('/report/' + id + '?type=daily')
          .then(function(response) {
            thisIns.updateDailyReports()

            thisIns.$vs.notify({
              text: 'Poročilo izbrisano',
              color: 'success'
            })
          }).catch(function() {
          thisIns.$vs.notify({
            text: 'Napaka pri brisanju poročila',
            color: 'danger',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
        }).finally(function() {
          thisIns.$vs.loading.close()
        })
      }
    },
    created() {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'))
      this.userId = userInfo.uid
      this.admin = userInfo.userRole

      this.updateDailyReports()
    }
  }
</script>
